export default __webpack_public_path__ + "static/aws-certified-cloud-practitioner-logo-e718d283f7733545027f83c0191f145f.png";